export const COLORS = {
    primaryBlue: "#0565ea",
    primaryBlue50: "#1f76fd",

    white: "#fff",

    gray10: "#FAFBFC",
    gray20: "#F6F6F6",
    gray30: "rgba(5,101,234,0.02)"
}

export const SIZES = {
    headerHeight: "60px",
    mainLayoutHeight: "calc(100vh - 60px)"
}

const theme = {COLORS, SIZES}

export default theme;